export const Errors = {
  DATA_NOT_READY: 'Data not ready',
  SOMETHING_WENT_WRONG: 'Something went wrong',
};

export const ErrorsMessages = {
  QUOTE_COVERWHALE_INVALID_SUBMISSION:
    'Your quote was not submitted.',
  SOMETHING_WENT_WRONG:
    'Something went wrong while getting the quote data. Please try again later.',
};
